/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Brand_PricesInputs */

const en_field_brand_prices = /** @type {(inputs: Field_Brand_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand prices`)
};

/**
* | output |
* | --- |
* | "Brand prices" |
*
* @param {Field_Brand_PricesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_brand_prices = /** @type {((inputs?: Field_Brand_PricesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Brand_PricesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_brand_prices(inputs)
});